import { createZodDto } from 'nestjs-zod';
import { userCredentials } from './user-credentials.req.dto';
import { userInfo } from './user-info.dto';

export class UserInfoPlusCredentials extends createZodDto(
  userInfo.merge(userCredentials),
) {}
